import React, { FC } from "react";

import { Col, Container, Row } from "reactstrap";

import CompanyDetail from "./CompanyDetail";

const CompanyPage: FC = () => {
  document.title =
    "Müşteri Bilgisi | Bu ekranda müşteri bilgileri düzenlemesi yapabilirsiniz";
  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  return (
    <React.Fragment>
      <div className={isMobile ? "page-content-mobile" : "page-content"}>
        <Container fluid>
          <Row>
            <Col xl={12}>
              <CompanyDetail />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CompanyPage;
